<div class="row-centered">
    <form (ngSubmit)="submit()" [formGroup]="templateForm" class="margin-form-container">

        <div formArrayName="activities">
            @for (act of activitiesFormArray.controls; track act; let i = $index) {
                <div class="mb-3 row"
                     [formGroupName]="i">
                    <mat-form-field class="mat-form-field-lg mr-1" appearance="outline">
                        <mat-label>Activity</mat-label>
                        <input type="text" required matInput formControlName="activity">
                        <mat-hint>
                            name of the activity
                        </mat-hint>
                    </mat-form-field>
                    <mat-form-field class="mr-1">
                        <mat-select formControlName="category" placeholder="Category">
                            @for (c of categories; track c) {
                                <mat-option [value]="c">
                                    {{ c }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="mr-1" appearance="outline">
                        <mat-label>Cost</mat-label>
                        <input type="text" required matInput formControlName="cost">
                        <mat-icon matSuffix>euro</mat-icon>
                    </mat-form-field>
                    <mat-form-field class="mat-form-field-lg">
                        <mat-label>Name</mat-label>
                        <input type="text" required matInput formControlName="name">
                        <mat-hint>
                            name of the activity
                        </mat-hint>
                    </mat-form-field>
                </div>
            }
        </div>

        <div class="give-margin-cell-reversed row">
            <button color="primary" i18n mat-raised-button [disabled]="!templateForm.valid" mat-button
                    type="submit">Submit changes
            </button>
        </div>

    </form>
</div>